<script setup></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="12" height="12" rx="1" />
    <rect x="5" y="5" width="3" height="3" rx="1.5" />
    <path
      d="M2 14L4.79613 10.8044C5.17706 10.3691 5.84678 10.3468 6.25582 10.7558L6.79289 11.2929C7.18342 11.6834 7.81658 11.6834 8.20711 11.2929L10.7929 8.70711C11.1834 8.31658 11.8166 8.31658 12.2071 8.70711L14 10.5"
    />
  </svg>
</template>

<style scoped lang="scss"></style>
